
<template>
  <v-container fluid grid-list-md>
    <v-layout column>
      <v-flex xs12>
        <v-card>
          <div class="flex xs12 page-header">Contact Us</div>
          <v-container fluid grid-list-md class="contact-container">
            <v-layout row wrap>
              <v-form v-model="valid" class="contact-form">
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <span v-if="messageSuccess">
                        <v-alert
                          :value="true"
                          color="success"
                          icon="check_circle"
                          outline
                        >
                          Your message has been sent.
                        </v-alert>
                      </span>
                      <span v-else-if="messageFail">
                        <v-alert
                          :value="true"
                          color="error"
                          icon="warning"
                          outline
                        >
                          There was an error sending your message.
                        </v-alert>
                      </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="contactName"
                        :rules="nameRules"
                        label="Name"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        label="Email"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="message"
                        :rules="nameRules"
                        label="Message"
                        required
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                    <v-btn
                      :disabled="!valid"
                      color="secondary"
                      v-on:click="onSubmit"
                    >
                      Send
                    </v-btn>
                    <div v-if="isSending" class="loading">Sending...</div>                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Contact',
  data: () => ({
    valid: false,
    contactName: '',
    message: '',
    nameRules: [
      v => !!v || 'Name is required'
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid'
    ],
    messageSuccess: false,
    messageFail: false,
    isSending: false
  }),
  methods: {
    clearForm () {
      for (let field in this.contact) {
        this.contact[field] = ''
      }
    },
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true
      }
    },
    onSubmit (evt) {
      evt.preventDefault()

      this.isSending = true

      setTimeout(() => {
        // Build for data
        let form = new FormData()
        for (let field in this.contact) {
          form.append(field, this.contact[field])
        }

        // Send form to server
        axios.post('/mailer/mailer.php', form).then((response) => {
          console.log(response)
          this.clearForm()
          this.isSending = false
          this.messageSuccess = true
          this.messageFail = false
        }).catch((e) => {
          console.log(e)
          this.isSending = false
          this.messageStatus = false
          this.messageFail = true
        })
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
  .contact-form {
    margin: 0 auto;
  }
</style>
